namespace Gamification.Gamification {
    export interface NodiForm {
        IdChecklist: Serenity.LookupEditor;
        Nome: Serenity.TextAreaEditor;
        Descrizione: Serenity.TextAreaEditor;
        IdRisorsa: Serenity.LookupEditor;
        Progressivo: Serenity.IntegerEditor;
        AnimationPath: Serenity.StringEditor;
    }

    export class NodiForm extends Serenity.PrefixedContext {
        static formKey = 'Gamification.Nodi';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!NodiForm.init)  {
                NodiForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.TextAreaEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.StringEditor;

                Q.initFormType(NodiForm, [
                    'IdChecklist', w0,
                    'Nome', w1,
                    'Descrizione', w1,
                    'IdRisorsa', w0,
                    'Progressivo', w2,
                    'AnimationPath', w3
                ]);
            }
        }
    }
}
